import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.hzmswI',
    defaultMessage: 'Groups',
  },
});
